<template>
  <!-- Two bars, both filled: the ad was step 1, this page is step 2. -->
  <div class="ladder">
    <span class="ladder__bar" aria-hidden="true"></span>
    <span class="ladder__bar" aria-hidden="true"></span>
    <span class="ladder__label">{{ complete ? t.ladderComplete : t.ladderStep }}</span>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useBrandStore } from '@/stores/brandStore'

defineProps({ complete: { type: Boolean, default: false } })

const { translations: t } = storeToRefs(useBrandStore())
</script>

<style scoped>
.ladder {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: var(--ladder-top);
}

.ladder__bar {
  flex: 1;
  height: 3px;
  border-radius: 9999px;
  background: var(--ladder-fill);
}

.ladder__label {
  padding-left: 4px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: .08em;
  white-space: nowrap;
  color: var(--ladder-label);
}
</style>
